import { apiClient } from './api'
import { resolveEventId } from './eventService'

export interface MyCheckin {
  token: string
  checkedIn: boolean
  checkedInAt?: string | null
  fullName?: string | null
  email?: string | null
}

export const checkinService = {
  me: async (): Promise<MyCheckin> => {
    const id = await resolveEventId()
    return apiClient.get<MyCheckin>(`/events/${id}/checkin/me`).then((r) => r.data)
  },
}
